import { useIntl } from "react-intl";
import Seo from "../../components/Seo";
import { Contact } from "../../containers/Contacts/Create";

/**
 * @typedef {object} Props
 * @property {any} [value]
 *
 * @param {Props} props
 */
function Page(props) {
  const intl = useIntl();

  return (
    <>
      <Seo
        title={intl.formatMessage({ defaultMessage: "Nous contacter" })}
        description={intl.formatMessage({
          defaultMessage: "Prenez rendez-vous avec votre conseiller",
        })}
      />

      <Contact />
    </>
  );
}

export default Page;

/**
 * @typedef {import("../../types/Page").PageInitialProps & Props} InitialProps
 *
 * @param {import("../../types/AppContext").PageContext} context
 *
 * @returns {Promise<InitialProps>}
 */
Page.getInitialProps = async function (context) {
  /** @type {InitialProps} */
  const values = {};

  return values;
};
